// Module
var code = "<div class=\"grid grid-cols-4 absolute left-0 w-full\"> <div id=\"sideNav\"></div> <div id=\"tabContentContainer\" class=\"container col-span-3\"></div> </div> ";
// Exports
export default code;